module.exports = __webpack_public_path__ + "static/full-stack-project-blockchain-2-7956da609edbddb514f17bd4e827c2fc.png";